/**
 * Shared styles for SSO forms
 */

.switch {
	span {
		font-size: var(--font-size--2xs);
		font-weight: var(--font-weight--bold);
		color: var(--color--text--tint-1);
	}
}

.buttons {
	display: flex;
	justify-content: flex-start;
	padding: var(--spacing--2xl) 0 var(--spacing--2xs);

	button {
		margin: 0 var(--spacing--sm) 0 0;
	}
}

.group {
	padding: var(--spacing--xl) 0 0;

	> label {
		display: inline-block;
		font-size: var(--font-size--sm);
		font-weight: var(--font-weight--medium);
		padding: 0 0 var(--spacing--2xs);
	}

	small {
		display: block;
		padding: var(--spacing--2xs) 0 0;
		font-size: var(--font-size--2xs);
		color: var(--color--text);
	}
}

.checkboxGroup label > *:first-child {
	// center checkbox next to label
	vertical-align: text-top;
}

.actionBox {
	margin: var(--spacing--2xl) 0 0;
}

.footer {
	color: var(--color--text);
	font-size: var(--font-size--2xs);
}
